export default "__VITE_ASSET__YlisNNLO__"